<template>
  <div class="h-full" v-show="visible">
    <section class="toast-box" v-show="showToast">
      <section class="toast-box-content">
        <p v-html="toastHtml"></p>
      </section>
    </section>
    <!-- <cc-loading-box class="loading" :isLoading="isLoading"></cc-loading-box> -->
    <div class="navList " :class="[navSatus?'expand':'fold']" >
      <a v-show="!navSatus" @mouseout="imgSrcObj.expand.status=0" @mouseover="imgSrcObj.expand.status=1"
         @click="changeNavStatus(1)">
        <img v-show="imgSrcObj.expand.status == 0" :src="images.expandImg">
        <img v-show="imgSrcObj.expand.status == 1" :src="images.expandActiveImg">
        <span>展<br>开<br>侧<br>边<br>栏</span>
      </a>
      <transition name="slide-fade">
        <ul>
          <li class="switchNavList">
            <a @mouseout="imgSrcObj.fold.status=0" @mouseover="imgSrcObj.fold.status=1" @click="changeNavStatus(0)">
              <img v-show="imgSrcObj.fold.status == 0" :src="images.foldImg">
              <img v-show="imgSrcObj.fold.status == 1" :src="images.foldActiveImg">
              <!-- <img :src="imgSrcObj.fold.src[imgSrcObj.fold.status]" > -->
            </a>
          </li>
          <li v-for="(item,index) in menu" class="router" :key="index">
            <a :class="{active:currentPath == item.path}" @click="changeMenu(item)" v-if="showMenu(item)">
              <span>{{item.title}}</span>
            </a>
          </li>
        </ul>
      </transition>
      <div class="logo"><img :src="images.logoImg"></div>
    </div>
    <div class="mian" :class="[navSatus?'':'fold']">
      <no-ssr>
        <nuxt keep-alive/>
      </no-ssr>
    </div>
  </div>
</template>
<script>
  import LoadingBox from '@/components/Cc-Loading';
  import {mapState} from 'vuex';
  export default {
    data() {
      return {
        visible: false,
        isLoading: false,
        currentPath: null,
        images: {
          foldImg: require("@/static/images/fold.png")
          , foldActiveImg: require("@/static/images/fold-active.png")
          , expandImg: require("@/static/images/expand.png")
          , expandActiveImg: require("@/static/images/expand-active.png")
          , logoImg: require("@/static/images/logo.png")
        }
        , imgSrcObj: {
          fold: {
            status: 0//0:鼠标移入,1:鼠标离开
            // ,src:[foldImg,foldActiveImg]
          }
          , expand: {
            status: 0
            // ,src:[expandImg,expandActiveImg]
          }
        }
        , menu: [
          {title: '用户信息', path: '/customer'}
          , {title: '下单界面', path: '/order'}
          , {title: '历史订单', path: '/orderList'}
        ]
        , navSatus: 1 // 0:收起,1：展开

        , toastHtml: ''
        , showToast: false
      }
    },
    created() {
      //this.currentPath = this.$route.path
      this.handleChang(this.$route)
      this.initEvent()
    },
    mounted() {
      setTimeout(() => {
        // Com.showToast(this, '999')
      }, 5000);
    },
    methods: {
      initEvent() {
      },
      changeNavStatus(status) {
        this.navSatus = status;
      },
      changeMenu(item) {
        let {path} = item;
        if (path === '/order' && !this.storeId) {
          this.$Modal.error({
            title: '提示', content: '请选择门店'
          });
          return
        }
        if(path === '/order' && this.isAmendNNew) {
          this.$Modal.error({
            title: '提示', content: '请选择门店点击【立即下单】进入下单界面页'
          });
          return
        }

        this.currentPath = path;
        // 此处用push 可记录跳转记录
        this.$router.push(path)
      },
      handleChang(route) {
        let path = route.path;
        this.visible = path !== '/choose';
        this.menu.forEach((value) => {
          if (value.path === path) {
            this.currentPath = path
          }
        })
      }
    },
    watch: {
      $route(to) {
        this.handleChang(to)
      }
    },
    components: {
      ccLoadingBox: LoadingBox
    },
    computed: {
      ...mapState({
        isAmend: state => state.booking.user.orderAmend.isAmend,
        newAmend: state => state.booking.user.newAmend, 
      }),
      storeId() {
        return this.$store.state.booking.user.storeId
      },
      isAmendNNew() {
        return this.isAmend && this.newAmend;
      },
      showMenu() {
        return function(menuItem) {
          if(menuItem.title == '历史订单' && this.isAmendNNew) {
            return false
          }
          return true
        }
      },
    }
  }
</script>

<style scoped>
  .mian {
    background-color: #f8fafc;
    position: relative;
    margin-left: 168px;
    min-width: 800px;
    /*height: 100%;*/
    padding-bottom: 55px;
    transition: all .4s ease;
  }

  .mian.fold {
    margin-left: 30px;
  }

  .mian.noNav {
    margin-left: 0;
  }

  .navList {
    position: fixed;
    background-color: #323a44;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 999;
    transition: all .4s ease;
  }

  .navList.fold {
    width: 30px;
  }

  .navList.expand {
    width: 168px;
  }

  .navList a {
    display: inline-block;
    cursor: pointer;
    width: 100%;
    text-align: center;
    color: #949ca6;

  }

  .navList.fold a {
    height: inherit;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 10px;
  }

  .navList.fold a span {
    margin-top: 10px;
  }

  .navList.fold:hover a {
    background-color: #1b2025;
    color: #e4e5ee;
  }

  .navList.expand .switchNavList a {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    background-color: #292f37;
  }

  .navList a img {
    width: 13px;
    height: 12px;
  }

  .navList .switchNavList:hover a {
    background-color: #1b2025;
    color: #e4e5ee;
  }

  .navList.expand .switchNavList:hover a::after {
    content: '收起侧边栏';
    display: inline-block;
    padding-left: 5px;
  }

  .navList .router a {
    padding: 4px 0;
    color: #949ca6;
    transition: .2s;
  }

  .navList .router a:hover {
    cursor: pointer;
  }

  .navList .router a span {
    display: inline-block;
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-left: 3px solid rgba(0, 0, 0, 0);
  }

  .navList .router a.active {
    background-color: #1b2025;
    color: #e4e5ee;
  }

  .navList .router a.active span {
    border-left: 3px solid #3bb5e4;
  }

  input[type=radio] {
    border-color: #707e89;
  }

  input[type=radio]:checked {
    border-color: #1e304d;
  }

  input[type=radio]:checked:after {
    background-color: #1e304d;
  }

  .slide-fade-enter-active, .slide-fade-leave-active {
    transition: all .4s ease;
  }

  .slide-fade-enter, .slide-fade-leave-active {
    opacity: 0;
  }

  .switchOrther {
    position: absolute;
    bottom: 20px;
    right: 0;
    width: 168px;
  }

  .switchOrther a {
    padding: 4px 0;
    height: 48px;
    line-height: 40px;
    color: #949ca6;
    width: 100%;
    text-align: center;
  }

  .logo {
    position: absolute;
    bottom: 80px;
    right: 38px;
  }

 
</style>

<style>
 .toast-box {
    position: fixed;
    height: 100%;
    z-index: 99999;
    left: 50%;
    right: 50%;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .toast-box-content {
    background: white;
    box-shadow: 0px 0px 8px #ccc;
    padding: 10px 15px;
    border-radius: 4px;
    min-width: 200px;
    min-height: 28px;
    text-align: center;
    /* color: #f47e5a; */
  }
</style>



// WEBPACK FOOTER //
// layouts/sidebar.vue